<div [ngClass]="'container-fluid ' + customCssClass">
  <ng-content></ng-content>
</div>
